"use client";

import React from "react";
import { Toaster } from "sonner";

export const ToastContainer = () => (
	<Toaster
		style={{ width: "100%", display: "flex", justifyContent: "center" }}
		toastOptions={{ className: "md:max-w-xl w-full" }}
		closeButton
		position="top-center"
		swipeDirections={["top", "left", "right"]}
	/>
);
